import { Link } from 'react-router-dom'
import { Fill, Shell } from '../components/Layout'

const VALUES = [
  'Every formula is built to respect the skin barrier first.',
  'Every active earns its place — nothing is added for the story.',
  'Premium formulas and beautiful packaging without the inflated price.',
  'Transparency, consistency and honest relationships for the long term.',
  'Skincare designed for the life you actually live, not an ideal one.',
]

export default function About() {
  return (
    <Shell>
      <section className="section-split" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1.05fr) minmax(0,1fr)', background: 'var(--sand)', minHeight: 'clamp(380px,42vw,560px)' }}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 20, padding: 'clamp(28px,5vw,80px)' }}>
          <div className="eyebrow">Our story</div>
          <h1 className="display h-hero" style={{ maxWidth: '17ch' }}>
            Beauty should never come at the expense of your skin.
          </h1>
          <p className="body-copy" style={{ maxWidth: '40ch' }}>
            Lumera began with a simple frustration: finding skincare that felt beautiful and luxurious, while still being gentle enough
            for sensitive skin and accessible enough to become part of an everyday routine.
          </p>
        </div>
        <div style={{ position: 'relative', minHeight: 'clamp(260px,36vw,560px)' }}>
          <Fill src="/assets/photos/apply-cream-profile.jpg" alt="A woman smoothing cream onto her cheek, glowing skin against a warm backdrop" label="Founder portrait" />
        </div>
      </section>

      <section className="section-split" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1.1fr)', gap: 'clamp(20px,3vw,48px)', alignItems: 'center', padding: 'clamp(40px,5vw,72px) clamp(16px,3vw,44px)' }}>
        <div style={{ position: 'relative', aspectRatio: '4 / 5', background: 'var(--stone)', overflow: 'hidden' }}>
          <Fill src="/assets/photos/apply-cream-bathroom.jpg" alt="A woman applying cream to her cheek in soft bathroom daylight" label="Founder" />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          <h2 className="display h-lg" style={{ maxWidth: '18ch' }}>
            A personal journey that started it all.
          </h2>
          <p className="body-copy" style={{ maxWidth: '48ch' }}>
            As the founder of Lumera, I know what it’s like to struggle with sensitive skin. For years, I searched for products that were
            effective, gentle and made with ingredients I could trust — without the harsh chemicals, without the inflated price tags, and
            without the empty promises.
          </p>
          <p className="body-copy" style={{ maxWidth: '48ch' }}>
            That search turned into a vision: to create a skincare brand that puts women’s skin, wellbeing and trust at the heart of
            everything we do.
          </p>
          <blockquote style={{ margin: '6px 0 0', paddingLeft: 20, borderLeft: '1px solid var(--rose-pale)', fontFamily: 'var(--serif)', fontSize: 'clamp(18px,2vw,25px)', fontWeight: 300, lineHeight: 1.45, color: 'var(--ink-soft)', maxWidth: '26ch' }}>
            I wanted to create skincare that felt gentle, worked, and was honestly within reach.
          </blockquote>
          <div style={{ fontSize: 11.5, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--muted)' }}>— Mira Sandoval, Founder</div>
        </div>
      </section>

      <section id="philosophy" className="section-split" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', background: 'var(--blush)', minHeight: 'clamp(300px,32vw,440px)' }}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 18, padding: 'clamp(28px,4vw,64px)' }}>
          <div className="eyebrow-rose">Created with sensitive skin in mind</div>
          <h2 className="display h-lg" style={{ maxWidth: '14ch' }}>
            Gentle care. Real results.
          </h2>
          <p style={{ margin: 0, fontSize: 13, fontWeight: 300, lineHeight: 1.85, color: '#4b3c3c', maxWidth: '44ch' }}>
            Sensitive skin can make beauty complicated. That’s why Lumera was created with a different philosophy: treat skin with care.
            We seek out thoughtfully formulated products and use advanced ingredients, while avoiding unnecessary, harsh or irritating
            additives.
          </p>
          <p style={{ margin: 0, fontSize: 13, fontWeight: 300, lineHeight: 1.85, color: '#4b3c3c', maxWidth: '44ch' }}>
            From prebiotics and peptides to niacinamide and carefully selected botanical ingredients, every Lumera product has a clear
            purpose within your routine.
          </p>
        </div>
        <div style={{ position: 'relative', minHeight: 'clamp(240px,30vw,440px)' }}>
          <Fill src="/assets/photos/bubbles-pink.jpg" alt="Macro of translucent pale pink bubbles suspended in clear gel" label="Prebiotic mist" />
        </div>
      </section>

      <section className="section">
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 'clamp(26px,3vw,42px)' }}>
          <h2 className="display h-md">Inspired by nature. Guided by science.</h2>
          <p className="small" style={{ margin: '0 auto', maxWidth: '58ch', lineHeight: 1.8 }}>
            We believe the future of beauty doesn’t require choosing between nature and innovation. Lumera brings together naturally
            derived and carefully selected ingredients with modern skincare actives, in formulas designed for the needs of today’s skin.
          </p>
        </div>

        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 'clamp(14px,2vw,26px)' }}>
          {VALUES.map((v, i) => (
            <li key={v} style={{ background: 'var(--stone)', padding: 'clamp(20px,2.4vw,30px)', display: 'flex', flexDirection: 'column', gap: 12 }}>
              <span style={{ fontFamily: 'var(--serif)', fontSize: 32, fontWeight: 300, color: 'var(--rose-pale)', lineHeight: 1 }}>0{i + 1}</span>
              <span style={{ fontSize: 13, fontWeight: 300, lineHeight: 1.75, color: '#463d36' }}>{v}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="section-split" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', background: 'var(--oat)', minHeight: 'clamp(260px,26vw,380px)' }}>
        <div style={{ position: 'relative', minHeight: 'clamp(220px,24vw,380px)' }}>
          <Fill src="/assets/photos/jar-bedside.jpg" alt="A white cream jar resting on a bedside surface in warm lamp light" label="The range" />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 18, padding: 'clamp(28px,4vw,64px)' }}>
          <h2 className="display h-lg" style={{ maxWidth: '18ch' }}>
            Created for women who want to understand their skin.
          </h2>
          <p style={{ margin: 0, fontSize: 13, fontWeight: 300, lineHeight: 1.85, color: '#4b423b', maxWidth: '40ch' }}>
            Care for it gently, and feel beautiful doing it. Start with the quiz and we will build the routine around you.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <Link to="/quiz" className="btn btn-solid" style={{ padding: '14px 30px' }}>
              Take the quiz
            </Link>
            <Link to="/shop" className="btn" style={{ padding: '14px 30px' }}>
              Shop the range
            </Link>
          </div>
        </div>
      </section>
    </Shell>
  )
}
